/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/Description",
  marginTop = 0,
  alignItems = "flex-start",
  justifyContent = "center"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Description.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z45GKT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ai-2-Z45GKT': alignItems,'--jc-3-Z45GKT': justifyContent}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}